import React from "react";
import { logError } from "../utils/errorLogger";

/** Catches render crashes so the pane shows a message and a reload button instead of going blank. */
export default class ErrorBoundary extends React.Component {
  state = { error: null, showDetails: false };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    try {
      const withStack = new Error(error?.message || String(error));
      withStack.stack = `${error?.stack || ""}\n--- component stack ---${info?.componentStack || ""}`;
      logError(withStack, "react.errorBoundary");
    } catch {
      /* reporting must never throw */
    }
  }

  render() {
    const { error, showDetails } = this.state;
    if (!error) return this.props.children;

    const button = {
      padding: "8px 14px", borderRadius: 8, border: "1px solid #475569", cursor: "pointer",
      background: "transparent", color: "inherit", fontSize: 13,
    };

    return (
      <div
        data-no-translate="true"
        style={{
          minHeight: "100vh", boxSizing: "border-box", padding: 20, display: "flex",
          flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12,
          textAlign: "center", background: "#0f1720", color: "#e2e8f0",
          fontFamily: "Segoe UI, sans-serif",
        }}
      >
        <div style={{ fontSize: 34 }}>⚠️</div>
        <div style={{ fontSize: 16, fontWeight: 600 }}>რაღაც შეცდომა მოხდა</div>
        <div style={{ fontSize: 13, color: "#94a3b8", maxWidth: 320 }}>
          შეცდომა ჩაიწერა. სცადეთ გვერდის თავიდან ჩატვირთვა — თქვენი მონაცემები სერვერზეა და არ დაიკარგება.
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button type="button" style={{ ...button, background: "#14b8c4", borderColor: "#14b8c4", color: "#06222a", fontWeight: 600 }}
            onClick={() => window.location.reload()}>
            თავიდან ჩატვირთვა
          </button>
          <button type="button" style={button} onClick={() => this.setState({ showDetails: !showDetails })}>
            {showDetails ? "დეტალების დამალვა" : "დეტალები"}
          </button>
        </div>
        {showDetails && (
          <pre
            style={{
              maxWidth: "100%", maxHeight: 200, overflow: "auto", textAlign: "left", fontSize: 11,
              padding: 10, borderRadius: 8, background: "#1e2530", color: "#fca5a5", whiteSpace: "pre-wrap",
            }}
          >
            {String(error?.message || error)}
          </pre>
        )}
      </div>
    );
  }
}
